import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild} from '@angular/core';
import { BnStepperComponent, Step } from "@bndes/bndes-ux4/bn-stepper";
import { Subject } from "rxjs";
import { AcompanhamentoDocumentoDepr, PeriodoAcompanhamentoDocumentoDepr } from '../../../../../model/acompanhamento-documento-depr.model';

export const STEP_EM_PREECHIMENTO = 0;
export const STEP_EM_VALIDACAO = 1;
export const STEP_VALIDADO_OU_REJEITADO = 2;

@Component({
  selector: "app-acompanhamento-depr-stepper",
  templateUrl: "./acompanhamento-depr-stepper.component.html",
  styleUrls: ["./acompanhamento-depr-stepper.component.scss"],
  standalone: false,
})
export class AcompanhamentoDeprStepperComponent implements OnChanges, OnDestroy {

  @ViewChild(BnStepperComponent) bnStepper: BnStepperComponent;
  steps: Step[] = [
    {
      name: "Em preenchimento",
      visited: false,
      done: false,
      disabled: true,
    },
    {
      name: "Em Validação",
      visited: false,
      done: false,
      disabled: true,
    },
    {
      name: "Validado/Rejeitado",
      visited: false,
      done: false,
      disabled: true,
    },
  ];
  private readonly destroy$ = new Subject();
  @Output() clickEmPreenchimento = new EventEmitter<boolean>();
  @Output() clickEmValidacao = new EventEmitter<boolean>();
  @Output() clickValidadoRejeitado = new EventEmitter<boolean>();
  @Input("acompanhamentoDepr") acompanhamentoDepr: AcompanhamentoDocumentoDepr;
  @Input("acompanhamentoDetalhe") acompanhamentoDetalhe: boolean;
  inicializado = false;
  podeClicar = false;

  constructor() {}

  async currentStepChange(currentStep: number) {
    console.log("currentStep", currentStep);
    if (this.inicializado && this.podeClicar) {
      if (currentStep === STEP_EM_PREECHIMENTO) {
        this.clickEmPreenchimento.next(true);
      } else if (currentStep === STEP_EM_VALIDACAO) {
        this.clickEmValidacao.next(true);
      } else if (currentStep === STEP_VALIDADO_OU_REJEITADO) {
        this.clickValidadoRejeitado.next(true);
      }
    }
    this.podeClicar = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['acompanhamentoDepr'] && changes['acompanhamentoDepr'].currentValue) {
      if (this.acompanhamentoDetalhe){
        switch (this.acompanhamentoDepr.estado.nomeEstado){
          case "Em preenchimento":
            this.steps[STEP_EM_PREECHIMENTO].done = true;
            this.steps[STEP_EM_PREECHIMENTO].visited = true;

            this.bnStepper.setCurrentStep(STEP_EM_PREECHIMENTO);
            break;
          case "Em validação":
            this.steps[STEP_EM_PREECHIMENTO].done = true;
            this.steps[STEP_EM_PREECHIMENTO].visited = true;

            this.steps[STEP_EM_VALIDACAO].done = true;
            this.steps[STEP_EM_VALIDACAO].visited = true;

            this.bnStepper.setCurrentStep(STEP_EM_VALIDACAO);
            break;
          case "Validado":
            this.steps[STEP_EM_PREECHIMENTO].done = true;
            this.steps[STEP_EM_PREECHIMENTO].visited = true;

            this.steps[STEP_EM_VALIDACAO].done = true;
            this.steps[STEP_EM_VALIDACAO].visited = true;

            this.steps[STEP_VALIDADO_OU_REJEITADO].done = true;
            this.steps[STEP_VALIDADO_OU_REJEITADO].visited = true;
            this.steps[STEP_VALIDADO_OU_REJEITADO].name = 'Validado';

            this.bnStepper.setCurrentStep(STEP_VALIDADO_OU_REJEITADO);
            break;
          case "Rejeitado":
            this.steps[STEP_EM_PREECHIMENTO].done = true;
            this.steps[STEP_EM_PREECHIMENTO].visited = true;

            this.steps[STEP_EM_VALIDACAO].done = true;
            this.steps[STEP_EM_VALIDACAO].visited = true;

            this.steps[STEP_VALIDADO_OU_REJEITADO].done = false;
            this.steps[STEP_VALIDADO_OU_REJEITADO].visited = true;
            this.steps[STEP_VALIDADO_OU_REJEITADO].name = 'Rejeitado';

            this.bnStepper.setCurrentStep(STEP_EM_VALIDACAO);
            break;
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }
}
